import { render, staticRenderFns } from "./bankDetails.vue?vue&type=template&id=60e26c8c&"
import script from "./bankDetails.vue?vue&type=script&lang=js&"
export * from "./bankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports